import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
        };
        return requestOptions
    }

}
// api
export const appointmentsListingApi = async ({ length, sort, page, name, date, status, patientID, sort_by }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}appointments?sort_order=${sort}&size=${length}&paginate=${page}&name=${name}&status=${status}&member_id=${patientID}&appointment_at_preferred=${date}&sort=${sort_by}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(["No data"]);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const appointmentsDetailsApi = async ({ id }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}appointment/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(data);
                    }
                } else {
                    reject(data);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addNewAppointments = async (appointments) => {
    const request = requestAuthOption("POST", appointments)
    try {
        const response = await fetch(`${server}appointment`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const delAppointments = async ({ id, msg }) => {
    const request = requestAuthOption("DELETE", msg)

    try {
        const response = await fetch(`${server}appointment/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const updateAppointments = async ({ id, appointments }) => {
    const request = requestAuthOption("PUT", appointments)
    try {
        const response = await fetch(`${server}appointment/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data);
                    } else if (data.code === "invalid_input") {
                        reject(data);
                    } else {
                        reject([data]);
                    }
                } else {
                    reject(data);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const confirmAppointment = async ({ id, appointments }) => {
    const request = requestAuthOption("PUT", appointments)
    try {
        const response = await fetch(`${server}appointment/${id}/remark`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addRemarksAppointment = async ({ id, appointments }) => {
    const request = requestAuthOption("PUT", appointments)
    try {
        const response = await fetch(`${server}appointment/${id}/remark`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};